import { render, staticRenderFns } from "./backgroundlogo.vue?vue&type=template&id=7bc1361d"
import script from "./backgroundlogo.vue?vue&type=script&lang=js"
export * from "./backgroundlogo.vue?vue&type=script&lang=js"
import style0 from "./backgroundlogo.vue?vue&type=style&index=0&id=7bc1361d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports